module.exports = __webpack_public_path__ + "img/method1.753d3979.png";